import { useState } from "react";
import { AppSelect, AppSelectOption } from "../../core/ui/atoms/AppSelect";
import { PaymentMethod } from "../../http/protocol";
import { t } from "../../i18n";

interface CryptoSelectsProps {
  groupMethods: PaymentMethod[];
  onMethodChange: (methodCode: string) => void;
  onNetworkChange: (networkCode: string, selectedMethodCode: string) => void;
  initialValue?: string | null; // preferred method
  latestUsedMethodCode?: string;
}

export const CryptoSelects = ({ groupMethods, onMethodChange, onNetworkChange, initialValue, latestUsedMethodCode }: CryptoSelectsProps) => {
  const [selectedMethodCode, setSelectedMethodCode] = useState<string | null>(initialValue || null);
  const methodNetworks = groupMethods.find((m) => m.code === selectedMethodCode)?.networks;

  return (
    <>
      <AppSelect
        initialValue={latestUsedMethodCode || initialValue || ""}
        onChange={(methodCode) => {
          setSelectedMethodCode(methodCode);
          onMethodChange(methodCode);
        }}
        renderActiveOption={(props) => <MethodOption method={props?.method}>{props?.label || ""}</MethodOption>}
      >
        {groupMethods.map((method) => (
          <AppSelectOption
            key={method.code}
            value={method.code || ""}
            label={t(`payments.method.${method.code}.name`, undefined, method.displayName) || ""}
            method={method}
          >
            <MethodOption method={method}>{t(`payments.method.${method.code}.name`, undefined, method.displayName) || ""}</MethodOption>
          </AppSelectOption>
        ))}
      </AppSelect>

      {selectedMethodCode && methodNetworks && methodNetworks.length > 0 && (
        <AppSelect
          key={selectedMethodCode}
          onChange={(networkCode) => onNetworkChange(networkCode, selectedMethodCode)}
          renderActiveOption={(props) => <>{props?.network?.displayName}</>}
          placeholder={t("cashier.choose-network")}
        >
          {methodNetworks.map((network) => (
            <AppSelectOption className="method-option" key={network.code} value={network.code || ""} label={network.displayName || ""} network={network}>
              <div className="app-select__method-name">{network?.displayName}</div>
            </AppSelectOption>
          ))}
        </AppSelect>
      )}
    </>
  );
};

const MethodOption: React.FC<{ method: PaymentMethod; children: React.ReactNode }> = ({ method, children }) => {
  return (
    <div>
      <img alt="method icon" className={`method-icon method-${method?.code?.toLowerCase()}`} />
      {children}
    </div>
  );
};
